import { createRootModal } from '../../RootModal';
import './CardDetailsInfo.scss';

const CardDetailsInfo = createRootModal(() => {
	return (
		<div className='CardDetailsInfo__container'>
			<div className='CardDetailsInfo__header'>
				Crypto Corporate Cards are ideal for business-related expenses, including:
			</div>
			<ul className='CardDetailsInfo__list'>
				<li>Payments for IT infrastructure, cloud services, and servers</li>
				<li>Booking flights and hotel accommodations worldwide</li>
				<li>Renting real estate, vehicles, and private/business jets</li>
				<li>Paying for advertising on Google, Facebook, and other digital platforms</li>
				<li>Buying tickets and sponsoring global events and conferences</li>
				<li>General business development and operational expenses</li>
			</ul>
			<h3 className='CardDetailsInfo__list-title'>This is perfect for companies that:</h3>
			<ul className='CardDetailsInfo__list'>
				<li>Want to provide seamless spending experiences for their teams and departments</li>
				<li>Need to manage global payments in USD while keeping crypto on the backend</li>
			</ul>
			<h3 className='CardDetailsInfo__list-title'>Get Your Crypto Corporate Card for Business in 1 hour</h3>
			<ul className='CardDetailsInfo__list'>
				<li>Onboarding fee: $500</li>
				<li>Minimum monthly fee: $500</li>
				<li>Exchange fee: 1% (crypto-to-USD swap fee when using the card)</li>
				<li>Personal account manager</li>
				<li>USD-based card</li>
				<li>24/7 support</li>
				<li>Flexible card limits</li>
			</ul>
		</div>
	);
});

export default CardDetailsInfo;
